export default {
  departures: [
    {
      id: 'f1',
      price: 477,
      stops: 0,
      from: {
        city: 'Sydney',
        airport: 'SYD',
        time: '10:30',
      },
      to: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '23:40',
      },
    },
    {
      id: 'f2',
      price: 576,
      stops: 1,
      from: {
        city: 'Sydney',
        airport: 'SYD',
        time: '13:40',
      },
      to: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '12:30',
      },
    },
    {
      id: 'f3',
      price: 774,
      stops: 2,
      from: {
        city: 'Sydney',
        airport: 'SYD',
        time: '15:45',
      },
      to: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '18:27',
      },
    },
    {
      id: 'f4',
      price: 891,
      stops: 0,
      from: {
        city: 'Sydney',
        airport: 'SYD',
        time: '11:50',
      },
      to: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '15:27',
      },
    },
    {
      id: 'f5',
      price: 987,
      stops: 3,
      from: {
        city: 'Sydney',
        airport: 'SYD',
        time: '9:55',
      },
      to: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '15:27',
      },
    },
  ],
  returns: [
    {
      id: 'r1',
      price: 564,
      stops: 1,
      from: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '23:40',
      },
      to: {
        city: 'Sydney',
        airport: 'SYD',
        time: '8:27',
      },
    },
    {
      id: 'r2',
      price: 670,
      stops: 0,
      from: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '17:00',
      },
      to: {
        city: 'Sydney',
        airport: 'SYD',
        time: '10:30',
      },
    },
    {
      id: 'r3',
      price: 887,
      stops: 2,
      from: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '19:40',
      },
      to: {
        city: 'Sydney',
        airport: 'SYD',
        time: '8:40',
      },
    },
    {
      id: 'r4',
      price: 1024,
      stops: 0,
      from: {
        city: 'San Francisco',
        airport: 'SFO',
        time: '23:40',
      },
      to: {
        city: 'Sydney',
        airport: 'SYD',
        time: '10:30',
      },
    },
  ],
};
